/**
 *
 * @returns
 */
export function solPagoServicioQuery() {
  return {
    as: 'factura',
    required: false,
    attributes: [
      'iId',
      ['sReferencia', 'referencia'],
      ['dImporteOriginal', 'importe'],
      ['dImportePagado', 'pagado'],
      ['sEstado', 'status'],
    ],
    include: [
      {
        as: 'adjuntos',
        required: false,
        attributes: ['iId'],
        where: {
          iRechazado: 1,
        },
      },

      {
        as: 'moneda',
        required: false,
        attributes: [['sCodigo', 'codigo']]
      },

      {
        as: 'autorizaciones',
        required: false,
        attributes: [
          'dImporteAutorizado',
          'dFechaAutorizada',
        ],

        include: [
          {
            as: 'pago',
            attributes: [
              'sNumeroTransferencia',
              'sEstado',
              'dFechaPago',
            ],
            where: {
              iActivo: true,
            }
          }
        ],

        where: {
          iActivo: true,
        },
      }
    ],
    where: {
      iActivo: true,
      sEstado: { $notIn: ['CANCELADA', 'PENDIENTE'] },
    },
  };
}
